import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, bibShape } from '@bibliocommons/bc-prop-types';

import './EditionAndLanguage.scss';

export default function EditionAndLanguage({ catalogBib, editions }) {
  if (!catalogBib) return null;

  function renderEdition() {
    const forceDisplayEdition = ['CDROM', 'VIDEO_GAME'].includes(catalogBib.getIn(['brief', 'format']));
    const multipleEditionsPresent = editions && editions.size > 0;
    if (!forceDisplayEdition && !multipleEditionsPresent) return null;

    const otherScriptEdition = catalogBib.getIn(['brief', 'otherScriptEdition']);
    const edition = catalogBib.getIn(['brief', 'edition']);

    return (
      <span className="bib-edition">
        {otherScriptEdition}
        {edition && otherScriptEdition ? ' • ' : null}
        {edition}
      </span>
    );
  }

  function renderLanguage() {
    const language = catalogBib.getIn(['brief', 'primaryLanguage']);
    if (!language || language === 'eng') {
      return null;
    }

    return (
      <span className="bib-language">
        <FormattedMessage id={`LANGUAGE.${language}`} />
      </span>
    );
  }

  const language = renderLanguage();
  const edition = renderEdition();

  return (
    <div className="cp-edition-language">
      {edition}
      {language && edition ? <> &mdash; </> : null}
      {language}
    </div>
  );
}

EditionAndLanguage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  editions: ImmutablePropTypes.listOf(bibShape).isRequired
};
